// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "hljs" + "." + "7ebc126220dbdeefaa2ff452d9fb8b3fb1435a68" + ".js";
};